<template>
  <div v-if="debug" class="pa-4">
    <strong>Link rotas Zuul:</strong> <a href="https://github.com/99Taxis/b2b-environment/blob/prd/b2b-zuul-app.yml" class="accent--text">
      https://github.com/99Taxis/b2b-environment/blob/prd/b2b-zuul-app.yml
    </a>
    <br>
    <br>
    <pre class="debug" v-html="highlight(claims)" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Debug',
  data () {
    return {
      debug: false
    }
  },
  methods: {
    highlight (text) {
      return JSON.stringify(text)
        .replace(/("\w+")/g, '<br>&nbsp;&nbsp;$1')
        .replace(/(},)/g, '<br>&nbsp;&nbsp;$1')
        .replace(/("ROLE_|"POP_99|"TURBO_TAXI|"REGULAR_TAXI|"TOP_99|"V2_PERMISSION|"WEBCALL_PERMISSION|"THIRDPARTY_WEBCALL_PERMISSION|"OWN_COST_CENTER)/g, '&nbsp;&nbsp;$1')
        .replace(/(})(})/, '<br>&nbsp;&nbsp;$1<br>$2')
        .replace(/(true|false)/g, '&nbsp;<span style="color: #ad80fe">$1</span>')
    }
  },
  computed: {
    ...mapState({
      claims: state => state.userClaims.claims,
      user: state => state.session.user.business
    })
  },
  created () {
    let pass = window.prompt('Insira a senha para visualizar as informações')
    if (`${pass}` !== `${this.user.email}@debug`) {
      this.$router.push({ name: 'Home' })
      return
    }

    this.debug = true
  }
}
</script>
